import { ActionContext, ActionTree } from 'vuex'
import { ChainStoreState, RootState } from '@/types/store'
import { getChainStores } from '@/api/chain-stores'

type Context = ActionContext<ChainStoreState, RootState>

export interface ChainStoreActions
  extends ActionTree<ChainStoreState, RootState> {
  getChainStores: (
    ctx: Context,
    params: { channelIds?: number[]; lastId?: number; limit?: number },
  ) => Promise<void>
  resetChainStores: (ctx: Context) => void
}

export const actions: ChainStoreActions = {
  async getChainStores({ commit }, params): Promise<void> {
    const chainStores = await getChainStores(params || {})
    commit('chainStoresLoaded', chainStores)
  },
  resetChainStores({ commit }): void {
    commit('chainStoresLoaded', [])
  },
}
